// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { LinkComponent, ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { SUCCESS_LINK_PROPS } from './constants/success-description-thank-you.constants';
// Styles
import { SuccessDescriptionBodyStyled } from 'containers/success/success.container.styled';
// Translations
import {
  MANAGE_INSTALLMENTS_DESCRIPTION_01,
  MANAGE_INSTALLMENTS_DESCRIPTION_02,
  MANAGE_INSTALLMENTS_DESCRIPTION_03,
} from './translations/success-description-thank-you.translations';
// Utils
import { getLoginLink } from './utils/success-description-thank-you.utils';

const SuccessDescriptionThankYouComponent = (): React.JSX.Element => (
  <SuccessDescriptionBodyStyled>
    <ParagraphComponent>
      <FormattedMessage id={MANAGE_INSTALLMENTS_DESCRIPTION_01} />
    </ParagraphComponent>
    <ParagraphComponent>
      <FormattedMessage id={MANAGE_INSTALLMENTS_DESCRIPTION_02} />
    </ParagraphComponent>
    <ParagraphComponent>
      <FormattedMessage
        id={MANAGE_INSTALLMENTS_DESCRIPTION_03}
        values={{
          loginLink: (
            <LinkComponent {...SUCCESS_LINK_PROPS} href={getLoginLink()}>
              {getLoginLink()}
            </LinkComponent>
          ),
        }}
      />
    </ParagraphComponent>
  </SuccessDescriptionBodyStyled>
);

export { SuccessDescriptionThankYouComponent };
